import { PlatformLocation } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { NbDialogRef, NbToastrService, NbDialogService } from '@nebular/theme';
import { RestService } from '../../../rest.service';
@Component({
  selector: 'ngx-session-time-out',
  templateUrl: './session-time-out.component.html',
  styleUrls: ['./session-time-out.component.scss'],
})
export class SessionTimeOutComponent implements OnInit {

  tokenId: number;
  // tslint:disable-next-line: max-line-length
  constructor(private route: Router, public ref: NbDialogRef<SessionTimeOutComponent>, public sanitizer: DomSanitizer, private toastrService: NbToastrService, private dialogService: NbDialogService, private location: PlatformLocation, private restService: RestService) {
    location.onPopState(() => this.ref.close());
  }

  ngOnInit() {
  }
  onLogIn() {
    // tslint:disable-next-line: radix
    this.tokenId = parseInt(localStorage.getItem('tokenId'));
    this.restService.model('UpdateLogInStatus/' + this.tokenId + '/' + 0 + '/' + 1).subscribe((response) => {
      if (response.status) {
        setTimeout(() => {
          this.route.navigate(['/auth/login']);
        }, 1000);
      }
    });
  }

  cancel() {
    this.ref.close();
  }

}

